export interface SiteNavItem {
  label: string;
  path: string;
}

export const siteNav: SiteNavItem[] = [
  { label: "首页", path: "/" },
  { label: "漫画分类", path: "/category" },
  { label: "资讯", path: "/news" },
  { label: "搜索", path: "/search" },
  { label: "关于", path: "/about" },
];

export interface TeamMember {
  name: string;
  role: string;
  icon: string;
}

export const teamMembers: TeamMember[] = [
  { name: "林夕", role: "内容主编", icon: "ri-quill-pen-line" },
  { name: "森野绘", role: "签约作者 · 插画", icon: "ri-palette-line" },
  { name: "阿澈", role: "资讯编辑", icon: "ri-newspaper-line" },
  { name: "苏晴", role: "特约撰稿", icon: "ri-chat-quote-line" },
];

export interface ContactItem {
  icon: string;
  label: string;
  value: string;
}

export const contactItems: ContactItem[] = [
  { icon: "ri-mail-line", label: "投稿与联系", value: "hello@yaojingmanhua.example" },
  { icon: "ri-phone-line", label: "合作热线", value: "400-888-2026" },
  { icon: "ri-map-pin-line", label: "编辑部地址", value: "青芽市幻想大道 12 号 · 妖精文化园" },
];

export interface AboutStat {
  value: string;
  label: string;
  icon: string;
}

export const aboutStats: AboutStat[] = [
  { value: "680+", label: "收录妖精漫画作品", icon: "ri-book-2-line" },
  { value: "18万", label: "月度活跃读者", icon: "ri-group-line" },
  { value: "1200+", label: "累计资讯发布", icon: "ri-newspaper-line" },
  { value: "40+", label: "合作作者与出版社", icon: "ri-hand-heart-line" },
];

export interface AboutValue {
  icon: string;
  title: string;
  desc: string;
}

export const aboutValues: AboutValue[] = [
  {
    icon: "ri-heart-3-line",
    title: "只为妖精题材",
    desc: "我们专注妖精、精灵与妖怪题材，做垂直而深入的漫画内容平台，而不是泛泛的作品仓库。",
  },
  {
    icon: "ri-sparkling-line",
    title: "认真筛选每一部作品",
    desc: "每一部上架作品都经过编辑团队通读与讨论，只把真正值得读的故事推荐给读者。",
  },
  {
    icon: "ri-user-smile-line",
    title: "陪读者一起成长",
    desc: "从分类筛选到资讯追踪，我们希望把发现好作品的整个过程，变得轻松又愉快。",
  },
];